import React from "react";
import { CalendarPlus, UserMinus, HeartHandshake, TrendingUp, CalendarX } from "lucide-react";
import { Reveal, SectionHeading, CountUp } from "../Reveal";
import { businessImpacts } from "../../mock";

const iconMap = { CalendarPlus, UserMinus, HeartHandshake, TrendingUp, CalendarX };

const ImpactSection = () => (
  <section id="impact" className="relative py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <SectionHeading
        eyebrow="Business Impact"
        title={<>Measurable outcomes for <span className="text-cyan-400">healthcare & hospitals</span></>}
        sub="AI automation at the front line of patient engagement — driving growth, efficiency and satisfaction."
      />

      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-5">
        {businessImpacts.map((b, i) => {
          const Icon = iconMap[b.icon];
          const numeric = b.metric.replace(/[^0-9]/g, "");
          const prefix = b.metric.startsWith("-") ? "-" : b.metric.startsWith("+") ? "+" : "";
          const suffix = b.metric.endsWith("%") ? "%" : b.metric.endsWith("+") ? "+" : "";
          return (
            <Reveal key={b.title} delay={i * 100}>
              <div className="card-dark card-dark-hover flex h-full flex-col rounded-3xl p-6">
                <div className="flex h-11 w-11 items-center justify-center rounded-xl border border-cyan-400/20 bg-cyan-400/10">
                  <Icon className="h-5 w-5 text-cyan-300" />
                </div>
                <div className="font-display mt-5 text-3xl font-bold text-white">
                  {prefix}
                  <CountUp target={numeric} suffix={suffix} />
                </div>
                <h3 className="font-display mt-2 text-sm font-semibold text-cyan-200">{b.title}</h3>
                <p className="mt-2 text-xs leading-relaxed text-slate-500">{b.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>

      <Reveal delay={200}>
        <p className="mt-8 text-center text-xs text-slate-600">
          Figures shown are illustrative targets based on typical hospital deployments.
        </p>
      </Reveal>
    </div>
  </section>
);

export default ImpactSection;
